import React from 'react';
import { Card, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { isNil } from 'lodash';

import { getFullName } from 'utils/personUtils';
import { getLocation } from 'utils/locationUtils';
import BaseLabel from 'components/wrappers/BaseLabel';
import { getPartnerStatusLabel } from 'utils/partnerUtils';
import { PartnerResponseModel } from 'api/backofficeApiClient';

import styles from './PartnerCard.module.less';

type Props = {
  partner: PartnerResponseModel;
  isMemberCompanyNameClickable: boolean;
};

export default function PartnerCard(props: Props) {
  const { partner, isMemberCompanyNameClickable } = props;
  const { id: partnerId, primaryContact, generalInfo, partnerStatus } = partner;

  const correctLocation = getLocation(
    generalInfo?.country,
    generalInfo?.address,
    generalInfo?.city || generalInfo?.internationalCityName,
    generalInfo?.state || generalInfo?.internationalStateName,
    generalInfo?.zipCode,
  );

  return (
    <Card className="card-item stretch-card" data-id={`partner-${partnerId}`}>
      <div className="card-inner">
        <div className="inner-text-box">
          <div className="card-title" data-id="partner-name">
            <Link to={`/partner/${partnerId}`}>{generalInfo?.companyName}</Link>
          </div>
        </div>
      </div>

      <Row gutter={[20, 10]} className="titled-sheet">
        {!isNil(generalInfo?.userCompanyName) && (
          <Col xs={24} md={12} data-id="member-company">
            <div className="title">Member company:</div>
            <div>
              {isMemberCompanyNameClickable ? (
                <Link to={`/member/${generalInfo?.userKey}`}>
                  {generalInfo?.userCompanyName}
                </Link>
              ) : (
                <span>{generalInfo?.userCompanyName}</span>
              )}
            </div>
          </Col>
        )}

        {(!isNil(primaryContact?.firstName) ||
          !isNil(primaryContact?.lastName)) && (
          <Col xs={24} md={12} data-id="primary-contact-name">
            <div className="title">Primary contact name:</div>
            <div>
              {getFullName(primaryContact?.firstName, primaryContact?.lastName)}
            </div>
          </Col>
        )}

        <Col xs={24} md={12} data-id="number-of-assignments">
          <div className="title">Number of assignments:</div>
          <div>{generalInfo?.assignmentsCount || 0}</div>
        </Col>

        {!isNil(primaryContact?.email) && (
          <Col xs={24} md={12} data-id="pc-email">
            <div className="title">PC email:</div>
            <div className="overflow-ellipsis">{primaryContact?.email}</div>
          </Col>
        )}

        {!!correctLocation && (
          <Col xs={24} md={12} data-id="location">
            <div className="title">Location:</div>
            <div>{correctLocation}</div>
          </Col>
        )}

        {!isNil(primaryContact?.phoneNumber) && (
          <Col xs={24} md={12} data-id="pc-phone-number">
            <div className="title">PC phone number:</div>
            <div>{primaryContact?.phoneNumber}</div>
          </Col>
        )}
        {!isNil(partnerStatus) && (
          <Col xs={24} className={styles.col} data-id="status-label">
            <BaseLabel status={getPartnerStatusLabel(partnerStatus)} />
          </Col>
        )}
      </Row>
    </Card>
  );
}
